import useWebChatUIContext from './useWebChatUIContext';

export default function useStyleToEmotionObject() {
  return useWebChatUIContext().styleToEmotionObject;
}
